/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { openDrawer } from "data/store/reducers/menu";
import { useApplication } from "hooks/use-application";
import { useLayout } from "hooks/use-layout";
import { useSchemaModel } from "hooks/use-schema-model";
import { LayoutWrapper } from "layout/layout-wrapper";
import { SideNav } from "layout/MainLayout/side-nav";
import { PrimaryHeader } from "layout/MainLayout/Header/primary-header";
import { SectionWrapper } from "./section-wrapper";
import { useRBAC } from "../../cms/auth/hooks/use-RBAC";
// import { ErrorToasterProvider } from "./error-toaster/error-toaster-provider";

const toggleDrawerOnQuery = (state) => async (dispatch) => {
    dispatch(openDrawer(state));
};

const MainLayout = () => {

    const theme = useTheme();
    const matchDownLG = useMediaQuery(theme.breakpoints.down("xl"));
    const dispatch = useDispatch();
    const { fetchApplicationData } = useApplication();
    const { fetchLayoutData } = useLayout();
    const { fetchSchemaModels } = useSchemaModel();
    const url = new URL(window.location.href);
    const domain = url.hostname;
    const { drawerOpen } = useSelector((state) => state.menu);
    const { initializeRBAC } = useRBAC();
    initializeRBAC();

    const [open, setOpen] = useState(drawerOpen); // drawer toggler - for button in header - currently disabled

    // set media wise responsive drawer
    useEffect(() => {
        setOpen(!matchDownLG);
        dispatch(toggleDrawerOnQuery({ drawerOpen: !matchDownLG }));
    }, [matchDownLG, dispatch]);

    useEffect(() => {
        if (open !== drawerOpen) {
            setOpen(drawerOpen);
        }
    }, [drawerOpen, open]);

    useEffect(() => {
        const initialize = async () => {
            // const [schemas, apps, layouts] = await Promise.all([
            await Promise.all([
                fetchSchemaModels(),
                fetchApplicationData(last_app_id, domain),
                fetchLayoutData(),
            ]);
        };
        const last_app_id = localStorage.getItem("CurrentApplication");
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LayoutWrapper>
            {/*<ErrorToasterProvider>*/}
            <div id='simplicity-layout-container' className='simplicity-layout-container'>

                <SideNav />

                <div id='simplicity-layout-main-all' className='simplicity-layout-main-all'>

                    <PrimaryHeader />

                    <SectionWrapper>

                        <Outlet />

                    </SectionWrapper>

                </div>

            </div>
            {/*</ErrorToasterProvider>*/}
        </LayoutWrapper>
    );
};

export { MainLayout };
